import { AuthServiceHelper } from '@/modules/Auth'
import { Routes } from '@/assets/configs'
import { useEMTDispatch } from '@/store'
import { useRouter } from 'next/router'
import { MessageEventData_Logout } from '@/data'

const useLogout = () => {
  const dispatch = useEMTDispatch()
  const router = useRouter()

  const onLogoutClickAsync = async () => {
    await AuthServiceHelper.dispatchLogoutAsync(dispatch)()

    // Webview tracking
    if (typeof window !== 'undefined' && typeof window.ReactNativeWebView !== 'undefined') {
      const eventData: MessageEventData_Logout = {
        event: 'logout',
      }
      window.ReactNativeWebView.postMessage(JSON.stringify(eventData))
    }

    localStorage.clear()
    router.push(Routes.Connection.SignIn)
  }

  return { onLogoutClickAsync } as const
}

export default useLogout
